// **Welcome!**
// Codex production brand config (assets aligned with https://www.codexblockchain.com/).

import brandIcon from "../assets/icons/logos/codex-icon.svg";
import brandLogoWithText from "../assets/icons/logos/codex-full-logo.png";
import brandLogo from "../assets/icons/logos/codex-icon.svg";
import brandSymbol from "../assets/icons/logos/codex-icon.svg";
import brandTokenIcon from "../assets/icons/logos/codex-token.svg";
import brandPrivateTokenIcon from "../assets/icons/logos/codex-native.svg";

import pageNotFoundImage from "@/images/page-not-found.png";
import serverErrorImage from "@/images/server-error.png";
import twitterLogo from "@/icons/logos/twitter.svg";
import facebookLogo from "@/icons/logos/facebook.svg";
import linkedInLogo from "@/icons/logos/linkedin.svg";
import discordLogo from "@/icons/logos/discord.svg";
import youtubeLogo from "@/icons/logos/youtube.svg";
import instagramLogo from "@/icons/logos/instagram.svg";

import shareHero from "@/images/StoreHero.svg";
import setupWallet from "@/images/Set-Up-Wallet.svg";
import shareSignup from "@/images/SmartWallet.png";
import noReferrals from "@/images/refer-a-friend_no-referrals.svg";
import blockFabric from "@/icons/logos/codex.svg";
import blockFabricHash from "../assets/icons/logos/codex-icon.svg";
import nodeBanner from "@/images/nodeBanner.svg";
import votingBanner from "@/images/voting.svg";

import { config } from "config";

const brandName = "CODEX United";
const brandChainName = "CODEX";
const brandCoin = "CDXR";
const staticSite = "https://app.codexblockchain.com";
const rpcUrl = "https://cloudflare-eth.com";
const domain = "codexblockchain.com";
const version = "latest";
const binaryBrand = "codex";
const contractAddress = "0x0000000000000000000000000000000000000001";
const chainID = 1;
const appUrl = "https://app.codexblockchain.com";
const bridgeFee = 1000;
const useV2Endpoints = true;

const nodeGovUrl = `https://codex.node-governance.io`;

export const brand = {
  brandName,
  brandChainName,
  staticSite,
  appUrl,
  nodeGovUrl,
  rpcUrl,
  contractAddress,
  chainID,
  bridgeFee,
  walletMigrationDate: "Dec 25, 2025",
  coin: brandCoin,
  useV2Endpoints,
  brandLogoHorizontalLight: brandLogoWithText.src,
  navLogoHeight: 72,
  // navLogoMaxWidth: "200px",
  brandLogoCompactLight: brandSymbol.src,
  navLogoCompactHeight: 40,
  brandLogoSymbolLight: brandSymbol.src,
  brandLogoHorizontalDark: brandLogoWithText.src,
  brandLogoCompactDark: brandSymbol.src,
  brandLogoSymbolDark: brandSymbol.src,
  authenticationLogo: brandSymbol.src,
  logoWithText: brandLogoWithText.src,
  logo: brandLogo.src,
  icon: brandIcon.src,
  tokenIconL2: brandPrivateTokenIcon.src,
  tokenIcon: brandTokenIcon.src,
  fallbackImages: {
    shareHero: shareHero.src,
    shareSignup: shareSignup.src,
    setupWallet: setupWallet.src,
    noReferrals: noReferrals.src,
    blockFabric: blockFabric.src,
    blockFabricHash: blockFabricHash.src,
    nodeBanner: nodeBanner.src,
    votingBanner: votingBanner.src,
  },
  loggedOutHomeRoute: "/",
  loggedInHomeRoute: "/home",
  previousSiteURL: "",
  blockFabricUrl: "https://app.blockfabric.host/?referralCode=Codex-NE",
  blockFabricTxnUrl: "https://etherscan.io/tx/",
  externalWalletEthAddress: "https://etherscan.io/address/",
  support: {
    url: "https://help.codexblockchain.com",
    target: "_blank",
  },
  nftSupportLinks: {
    boost: "",
    activatable: "",
    carbonCredit: "",
  },
  storeFilterCategories: {
    nodes: "category-2",
    other: "category-1",
  },
  cookiesPreferencesKey: "CodexCookiesPreferences",
  cookiesDomain:
    config.environment === "local" ? "localhost" : ".codexblockchain.com",
  cookiesExpiration: new Date(Date.now() + 300000),
  nodeSetupBashCommands: {
    vps: `bash <(curl -s https://download.${domain}/node-binaries/${version}/linux.sh)`,
    mac: `bash <(curl -s https://download.${domain}/node-binaries/${version}/mac.sh)`,
    linux: {
      sudo1: 'sudo chown -R "{your_username}:" /usr/local/bin',
      sudo2: 'sudo chown -R "{your_username}:" /etc/systemd/system',
      bash: `bash <(curl -s https://download.${domain}/node-binaries/${version}/linux.sh)`,
      sudo3: `sudo systemctl start ${binaryBrand}`,
      sudo4: `systemctl status ${binaryBrand}`,
    },
  },
  helpDoc:
    "https://core-sdk-dev-public-temp.s3.us-west-2.amazonaws.com/docs/BrandNodeHelpDocument.pdf",
  socialMediaSites: {
    twitter: {
      url: "https://twitter.com",
      icon: twitterLogo.src,
      isActive: false,
      buttonBackgroundColor: "#00acee",
    },
    discord: {
      url: "https://discord.com",
      icon: discordLogo.src,
      isActive: false,
      buttonBackgroundColor: "#7289D9",
    },
    linkedIn: {
      url: "https://linkedin.com",
      icon: linkedInLogo.src,
      isActive: false,
      buttonBackgroundColor: "#0a66c2",
    },
    facebook: {
      url: "https://facebook.com",
      icon: facebookLogo.src,
      isActive: false,
      buttonBackgroundColor: "#1877f2",
    },
    instagram: {
      url: "https://instagram.com",
      icon: instagramLogo.src,
      isActive: false,
      buttonBackgroundColor: "transparent",
    },
    youtube: {
      url: "https://youtube.com",
      icon: youtubeLogo.src,
      isActive: false,
      buttonBackgroundColor: "#C4302B",
    },
  },
  errorMessages: {
    genericError: "Something has gone wrong, please try again later.",
    inputValidationFields: {
      name: "Improperly formatted name",
      email: "Enter a valid email (john@example.com)",
      password: "Password does not meet the character requirement",
      confirmPassword: "Passwords do not match",
      checkbox: "You must be over 18 to sign up.",
      phone: "Improperly formatted phone number",
    },
    birthDateError: "Invalid Date Format, please use MM/DD/YYYY",
    birthDateAge: "Please check the year",
  },
  pages: {
    login: {
      title: `Login to ${brandName}`,
    },
    dashboard: {
      walletCoins: ["USDC", "ETH", "BTC"],
      useBrandCoin: true,
    },
    referFriend: {
      howPointsAreAwarded: `Explanation about how many points are awarded by each node and signup (decided by ${brandName}).`,
    },
    voting: {
      charterKey: "codex-charter-placeholder",
      charterFile:
        "https://core-sdk-dev-public-temp.s3.us-west-2.amazonaws.com/docs/BrandNodeHelpDocument.pdf",
      charterPageQuantity: 1,
    },
    errorPages: {
      serverFailed: {
        title: "500 Internal server error.",
        subText:
          "We are unable to complete this request. Please try again later.",
        notRecordedImage: serverErrorImage.src,
      },
      infoPageOffline: {
        title: "You are currently offline.",
        subText: "Please check your internet connection and try again.",
        image: pageNotFoundImage.src,
      },
    },
  },
};
